<template>
  <MultipleChoicesDropdown
    title="Country"
    :value="value"
    :show-clear-all="false"
    :single-choice="true"
    :search-enabled="true"
    :choices="choices"
    @change="onChange($event)"
  />
</template>

<script>
import { COUNTRIES_CHOICES } from 'services/countries'

export default {
  props: {
    value: { type: String, default: '' },
  },
  data: () => ({
    choices: COUNTRIES_CHOICES,
  }),
  methods: {
    onChange(choice) {
      this.$emit('change', choice)
    },
  },
}
</script>
